export default __webpack_public_path__ + "static/media/server-illustration.4bf34de6.svg";